/**
 * Post view count
 * 
 * Counting post view by ajax
 *
 * @version 3.0.0
 */
document.addEventListener("DOMContentLoaded", function () {
  const postViews = document.querySelectorAll(".js-post-view .post_count");

  const params = bagusPostViewParams;

  fetch(params.api_url, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    body: JSON.stringify({ id: params.post_id }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response && postViews.length) {
        postViews.forEach((postView) => (postView.innerHTML = response.count));
      }
    })
    .catch((error) => console.log(error));
});
